/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliInstitutionConfigDtoApiResponse } from '../../models/amoxcalli-institution-config-dto-api-response';

export interface ApiInstitutionConfigGet$Plain$Params {
  institutionId?: string;
}

export function apiInstitutionConfigGet$Plain(http: HttpClient, rootUrl: string, params?: ApiInstitutionConfigGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliInstitutionConfigDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiInstitutionConfigGet$Plain.PATH, 'get');
  if (params) {
    rb.query('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliInstitutionConfigDtoApiResponse>;
    })
  );
}

apiInstitutionConfigGet$Plain.PATH = '/api/institution-config';
